import type { SVGProps } from "react";

const SvgWiseSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-32.0 -32.0 576.0 576.0"
    width="1em"
    height="1em"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h512v512H0z" />
      <path
        fill="#00C6FF"
        fillRule="nonzero"
        d="m127.004 77.596 57.907 96.042-98.164 96.042H256.94l18.362-38.135h-97.46l57.909-58.612-35.307-56.498h159.594L221.628 444.81h47.316l155.36-367.215z"
      />
    </g>
  </svg>
);
export default SvgWiseSmallLogo;
